/* eslint-disable vue/multi-word-component-names */

<template>
  <main class="home">
    <a href="/products/ljsportservices" class="home__img-link  home__main">
      <img src="https://res.cloudinary.com/mjcc/image/upload/cs_srgb,f_auto,q_auto/v1554744533/HomeImages/home_PrimaryImg.jpg" alt="dark banner for personal training company ljsportservices showing back of toned women" />
      <div class="home__overlay">
        <span class="home__overlay-text">ljsportservices</span>
      </div>
    </a>
    <a href="/products/blinds2go" class="home__img-link  home__secondary">
      <img src="https://res.cloudinary.com/mjcc/image/upload/c_crop,f_auto,g_west,h_1292,w_1138,x_35,y_0/v1552637827/productImages/b2g_productImgHome.jpg" alt="blinds 2go website wooden blinds collection page shown on an iPad and iPhone beauty shot" />
      <div class="home__overlay">
        <span class="home__overlay-text">blinds 2go</span>
      </div>
    </a>
    <a href="/products/lockdown-1" class="home__img-link  home__tertiary">
      <img src="https://res.cloudinary.com/mjcc/image/upload/f_auto,q_auto:best/v1597657599/HomeImages/rickVenom_homeImg.jpg" alt="a drawing of rick covered in venom from the spiderman comics" />
      <div class="home__overlay">
        <span class="home__overlay-text">new illustrations</span>
      </div>
    </a>
  </main>
</template>

<script type="text/javascript">
export default {
  title: "mjccreative | home"
};
</script>

<style lang="scss" scoped>
@use "../assets/scss/_siteVariables";

.home {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  &__img-link {
    display: block;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    position: relative;
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 30px;
  }
  &__overlay {
    display: none;
  }
  @media only screen and (min-width: 1000px) {
    &__overlay {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 15px;
      right: 15px;
      height: 100%;
      opacity: 0;
      transition: 0.5s ease;
      background-color: rgba(247, 30, 82, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      border-radius: 10px;
      &:hover {
        opacity: 1;
      }
    }
    &__overlay-text {
      color: var(--white);
      font-size: 45px;
      font-weight: bold;
    }
  }
  @media only screen and (min-width: 600px) {
    &__secondary {
      flex: 0 0 41.66667%;
      max-width: 41.66667%;
    }
    &__tertiary {
      flex: 0 0 58.33333%;
      max-width: 58.33333%;
    }
  }
  img {
    width: 100%;
    display: block;
    height: auto;
    border-radius: 10px;
    // outline: 1px solid var(--light-grey);
  }
}
</style>
